import Config from 'config';
import { TFormScriptEventNames } from '../../../../store/appStateSlice';
import { IApiaDataGrid } from '../../../../store/dataGridSlice/types';
import { makeCellFieldId } from '../../../../store/dataGridSlice/util';
import {
  IApiaCommonComponent,
  TApiaComponent,
  TFrmParent,
} from '../../../../types';
import { arrayOrArray, noNaN } from '../../../../utils/util';

export const sortFieldsCoordinates = (
  field: TApiaComponent[],
): TApiaComponent[] => {
  field.sort((a, b) => {
    const ax: number = a.x;
    const ay: number = a.y;
    const bx: number = b.x;
    const by: number = b.y;
    if (ay === by) return ax - bx;
    if (ax === bx) return ay - by;
    return ay - by || ax - bx;
  });
  return field;
};

export const getFormEventType = (
  formName: string,
  formLoadReloadObj: Record<string, 'load' | 'reload'>,
): TFormScriptEventNames | null => {
  if (formLoadReloadObj) {
    let evt = null;
    Object.entries(formLoadReloadObj).forEach(([key, value]) => {
      if (key === formName) {
        evt =
          value === 'load' ? 'onLoad-scripts-ready' : 'onReload-scripts-ready';
      }
    });
    return evt;
  }
  return null;
};

export const getCurrentFormEventTypeByFormName = (
  formName: string,
  formType: TFrmParent,
): TFormScriptEventNames => {
  if (formType === 'E')
    return getFormEventType(formName, Config.LOAD_RELOAD_MAP_E);
  if (formType === 'P')
    return getFormEventType(formName, Config.LOAD_RELOAD_MAP_P);
  return null;
};

export const checkAllFieldsAreMounted = (src: string[], target: string[]) =>
  target.every((v) => src.includes(v));

export const getFormIDs = (
  formField: TApiaComponent | TApiaComponent[],
  formId: string,
): string[] => {
  const formFieldIds: string[] = [];
  arrayOrArray(formField).forEach((current: IApiaCommonComponent) => {
    formFieldIds.push(`${formId}_${current.id}`);

    if (
      current.fieldType === 'grid' &&
      !(current.properties as any)?.gridQuery
    ) {
      const grid = current as unknown as IApiaDataGrid;
      const isPaged = grid.properties.paged;
      const startIndex = noNaN(grid.startIndex);
      const rowsPerPage = noNaN(grid.properties.pagedGridSize);
      const rowsCount = noNaN(
        arrayOrArray(arrayOrArray(grid.field)[0].fieldValue).length,
      );
      const columns = arrayOrArray(grid.field).length;

      const endIndex = isPaged
        ? Math.min(startIndex + rowsPerPage, rowsCount)
        : rowsCount;

      for (let i = 0; i < endIndex - startIndex; i++) {
        formFieldIds.push(
          makeCellFieldId(`${formId}_${grid.id}`, columns - 1, i),
        );
      }
    }
  });
  return formFieldIds;
};
